import { heroStats, tickerItems } from '@/mocks/home';

export default function Hero() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dynamic%20flowing%20ribbon%20texture%20in%20deep%20charcoal%20with%20coral%20orange%20and%20amber%20highlights%2C%20editorial%20minimal%20background%20with%20soft%20grain%20and%20depth%2C%20no%20text&width=1800&height=1100&seq=freekanliao-hero-main&orientation=landscape"
          alt="免费看料 实时最新内容主视觉背景"
          title="免费看料 今日实时最新 刚刚抢先首发"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative mx-auto flex min-h-[520px] w-full max-w-shell flex-col justify-center px-4 pb-24 pt-28 md:min-h-[640px] md:px-6 md:pb-28 md:pt-32">
        <div className="w-full max-w-2xl raise-in">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-950/30 px-3.5 py-1.5 text-xs tracking-wide text-background-50 backdrop-blur">
            <span className="live-dot relative inline-flex h-1.5 w-1.5 rounded-full text-accent-400">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
            </span>
            全网动态 · 实时同步中
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
            免费看料
            <span className="mt-3 block text-lg font-semibold tracking-[0.18em] text-accent-300 md:text-2xl">
              今日 · 实时 · 最新 · 刚刚
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
            紧盯全网动态，热门内容抢先看。首发爆料不拖延，第一时间同步更新，让你永远快人一步。
          </p>

          <form
            className="mt-8 flex w-full max-w-lg flex-col gap-2 sm:flex-row"
            onSubmit={(e) => e.preventDefault()}
          >
            <label className="flex flex-1 items-center gap-2 rounded-full border border-background-50/25 bg-background-950/35 px-4 py-3 backdrop-blur">
              <i className="ri-search-line text-base text-background-100/70"></i>
              <input
                type="text"
                name="hero_keyword"
                placeholder="搜索今日最新、刚刚发生的热门内容"
                className="w-full bg-transparent text-sm text-background-50 placeholder:text-background-100/60 focus:outline-none"
              />
            </label>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即看料
            </button>
          </form>

          <dl className="mt-10 grid grid-cols-1 gap-x-8 gap-y-5 border-t border-background-50/15 pt-6 sm:grid-cols-3">
            {heroStats.map((stat) => (
              <div key={stat.id}>
                <dt className="text-xs tracking-wide text-background-100/70">{stat.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-bold text-background-50 md:text-3xl">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 border-t border-background-50/15 bg-background-950/45 backdrop-blur">
        <div className="mx-auto flex max-w-shell items-center gap-4 px-4 py-3 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-medium text-accent-300">
            <i className="ri-flashlight-fill text-sm"></i>
            快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex w-max min-w-full items-center gap-10">
              {loopItems.map((item, idx) => (
                <span key={`${item.id}-${idx}`} className="flex shrink-0 items-center gap-2 text-xs text-background-100/85">
                  <span className="rounded-sm bg-background-50/10 px-1.5 py-0.5 text-[10px] text-accent-200">{item.time}</span>
                  {item.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}